import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import { isJustGiving } from '../../../lib/environment'

import Button from '../../ui/Button'
import EditAccountForm from './EditAccountForm'
import EditFitnessForm from './EditFitnessForm'
import EditPageForm from './EditPageForm'
import EditProfilePictureForm from './EditProfilePictureForm'
import FlatModal from '../../ui/FlatModal'
import Grid from 'constructicon/grid'
import GridColumn from 'constructicon/grid-column'
import Heading from 'constructicon/heading'
import Section from 'constructicon/section'

class EditPage extends React.Component {
  constructor () {
    super()
    this.state = {
      open: false,
      selected: 'page'
    }
  }

  render () {
    const { classNames, fitnessOptions, fundraisingPage, styles, user } = this.props
    const { open, selected } = this.state

    const tabs = {
      page: {
        label: 'Page',
        Form: EditPageForm
      },
      profilePicture: {
        label: 'Profile Picture',
        Form: EditProfilePictureForm
      },
      fitness: {
        hide: !fitnessOptions.allow,
        label: 'Fitness Providers',
        Form: EditFitnessForm
      },
      account: {
        label: 'Account',
        Form: EditAccountForm
      }
    }

    const { Form, label } = tabs[selected]

    return (
      <div>
        <Button
          onClick={() => this.setState({ open: true })}>
          Edit Page
        </Button>
        <FlatModal
          contentLabel='Edit Page'
          isOpen={open}
          onRequestClose={() => this.setState({ open: false })}>
          <Grid
            align='stretch'
            styles={styles.grid}>
            <GridColumn sm={4}>
              <nav className={classNames.nav}>
                <ol>
                  {Object.keys(tabs).map(key => {
                    const tab = tabs[key]
                    const isSelected = key === selected

                    if (tab.hide) return null

                    return (
                      <li key={key}>
                        <button
                          className={isSelected && classNames.current}
                          onClick={() => this.setState({ selected: key })}>
                          {tab.label}
                        </button>
                      </li>
                    )
                  })}
                </ol>
              </nav>
            </GridColumn>
            <GridColumn sm={8}>
              <Section>
                <Heading spacing={{ b: 1 }}>
                  {`Edit ${label}`}
                </Heading>
                <Form
                  fitnessOptions={fitnessOptions}
                  fundraisingPage={fundraisingPage}
                  pageId={isJustGiving() ? fundraisingPage.slug : fundraisingPage.id}
                  user={user}
                />
              </Section>
            </GridColumn>
          </Grid>
        </FlatModal>
      </div>
    )
  }
}

export default withStyles(styles)(EditPage)
